<template>
	<div class="answer-list">
		<div class="card">
			<div class="card-body detail-box">
				<div class="mb-3">
					<span class="titles"> {{ visits.outlet.name }}</span>
				</div>
				<div class="dash-card">
					<span class="details">ادرس مشتری:{{ visits.outlet.address }}</span>
					<span class="details">کد مشتری:{{ visits.outlet.code }}</span>
					<span class="details">شهر مشتری:{{ visits.outlet.city.name }}</span>
					<span class="details">نوبت ویزیت:{{ visits.visit_turn }}</span>
					<span class="details"
						>نیروی اجرایی:{{ visits.promoter.first_name + ' ' + visits.promoter.last_name }}</span
					>
					<span class="details"
						>زمان شروع ویزیت:

						<date-picker
							v-model="visits.start_datetime"
							type="datetime"
							format="YYYY-MM-DD HH:mm"
							display-format="jYYYY-jMM-jDD HH:mm"
							:timezone="true"
							:disabled="true"
						/>
					</span>
					<span v-if="visits.has_due_date" class="details"
						>زمان اجرا:

						<date-picker
							v-model="visits.due_date"
							type="date"
							format="YYYY-MM-DD"
							display-format="jYYYY-jMM-jDD"
							:disabled="true"
						/>
					</span>
					<hr class="solid" />
					<div>
						<p>بازخورد</p>
						<span>کاربر: {{ modalName }} {{ modalLastName }}</span>
						<b-form-textarea
							id="textarea"
							v-model="commentData.visit_comment"
							placeholder=""
							rows="3"
							max-rows="6"
							class="mt-2"
							style="border-radius: 8px"
						></b-form-textarea>
						<div class="d-flex flex-row justify-content-end w-100 mt-3">
							<button @click="acceptComment" class="accept-modal">ذخیره</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-for="list in catList" :key="'cat' + list.id" class="card mt-4">
			<div class="card-body">
				<div class="mb-3">
					<span class="answers-title"> {{ list.verbose_name }}</span>
				</div>
				<div class="d-flex justify-content-between">
					<div class="flex-column w-50">
						<div class="mb-4" v-for="answers in answerList" :key="'answer' + answers.id">
							<div v-if="list.id === answers.question.report_category.id">
								<div class="titles mb-1">{{ answers.question.text }}</div>
								<p class="desc">{{ answers.question.description }}</p>
								<p class="short_text">{{ answers.question.short_text }}</p>
								<div v-for="answerType in answers.question.answer_type" :key="answerType.id">
									<div
										class="d-flex flex-row align-items-center"
										v-if="answerType.name === 'YesNo'"
									>
										<div class="box">
											<span class="answers-box" v-if="answers.bool === true"> بله</span>
											<span class="answers-box" v-if="answers.bool === false"> خیر</span>
										</div>
										<img
											class="edit-icon"
											@click="editFeild(answers)"
											src="../../assets/images/iconPack/edit1.png"
										/>
									</div>
									<div
										class="d-flex flex-row align-items-center"
										v-if="answerType.name === 'Triple'"
									>
										<div class="box">
											<span class="answers-box" v-if="answers.bool === true"> بله</span>
											<span class="answers-box" v-if="answers.bool === false"> خیر</span>
											<span class="answers-box" v-if="answers.bool === null"> ندارد</span>
										</div>
										<img
											class="edit-icon"
											@click="editFeild(answers)"
											src="../../assets/images/iconPack/edit1.png"
										/>
									</div>
									<div v-if="answerType.name === 'Score'">
										<div class="d-flex flex-row align-items-center">
											<div class="box">
												<span class="persian-number" v-if="answers.score === 1">1</span>
												<span class="persian-number" v-if="answers.score === 2">2</span>
												<span class="persian-number" v-if="answers.score === 3">3</span>
												<span class="persian-number" v-if="answers.score === 4">4</span>
												<span class="persian-number" v-if="answers.score === 5">5</span>
											</div>
											<img
												class="edit-icon"
												@click="editFeild(answers)"
												src="../../assets/images/iconPack/edit1.png"
											/>
										</div>
									</div>
									<div v-if="answerType.name === 'RadioChoice'">
										<div class="d-flex flex-row align-items-center">
											<div class="box">
												<span class="answers-box">{{ answers.radio.answer }}</span>
											</div>
											<img
												class="edit-icon"
												@click="editFeild(answers)"
												src="../../assets/images/iconPack/edit1.png"
											/>
										</div>
									</div>
									<div v-if="answerType.name === 'DropDownList'">
										<div class="d-flex flex-row align-items-center">
											<div class="box">
												<span class="answers-box">{{ answers.dropdown.answer }}</span>
											</div>
											<img
												class="edit-icon"
												@click="editFeild(answers)"
												src="../../assets/images/iconPack/edit1.png"
											/>
										</div>
									</div>
									<div
										class="d-flex flex-row align-items-center"
										v-if="answerType.name === 'Input'"
									>
										<div class="box">
											<span class="answers-box">{{ answers.text }}</span>
										</div>
										<img
											class="edit-icon"
											@click="editFeild(answers)"
											src="../../assets/images/iconPack/edit1.png"
										/>
									</div>
									<div class="d-flex align-items-center" v-if="answerType.name === 'Description'">
										<textarea
											:disabled="true"
											v-model="answers.description"
											rows="4"
											cols="50"
											class="mt-4"
											style="border-radius: 8px"
										>
										</textarea>
										<img
											class="edit-icon"
											@click="editFeild(answers)"
											src="../../assets/images/iconPack/edit1.png"
										/>
									</div>
									<div class="d-flex" v-if="answerType.name === 'Multichoice'">
										<div class="d-flex flex-row">
											<div
												v-for="multiAnswers in answers.multichoice"
												:key="multiAnswers.id"
												class="box"
											>
												<span class="answers-box"> {{ multiAnswers.answer }} </span>
											</div>
										</div>
										<img
											class="edit-icon"
											@click="editMultiFeild(answers)"
											src="../../assets/images/iconPack/edit1.png"
										/>
									</div>

									<div class="d-flex align-items-center" v-if="answerType.name === 'Number'">
										<span class="short-text">{{ answers.question.short_text }} :</span>
										<div class="box">
											<span class="answers-box"> {{ answers.number }} </span>
										</div>
										<img
											class="edit-icon"
											@click="editFeild(answers)"
											src="../../assets/images/iconPack/edit1.png"
										/>
									</div>
								</div>
							</div>
						</div>
						<div class="btns justify-content-start">
							<button class="accept" @click="nullAnswers(list.id)">افزودن پاسخ</button>
						</div>
					</div>

					<div class="d-flex flex-wrap w-50 justify-content-end">
						<div v-for="(image, index) in images" :key="image.id">
							<div class="ml-3 mb-3" v-if="list.id === image.type.report_category.id">
								<img @click="callModalimage(index)" class="answers-images" :src="image.link" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<b-modal hide-footer hide-header centered v-model="editModal">
			<div class="py-3 d-flex flex-column">
				<span class="font-weight-bold mb-2">ویرایش اطلاعات</span>
				<span class="question-txt">{{ modaltext }}</span>
				<span class="question-txt font-weight-bold">{{ modalShortText }}</span>

				<div v-for="model in modalAnswerType" :key="model.id">
					<select class="w-100" v-model="modalBool" v-if="model.name === 'YesNo'">
						<option :value="true">بله</option>
						<option :value="false">خیر</option>
					</select>
					<select class="w-100" v-model="modalBool" v-if="model.name === 'Triple'">
						<option :value="true">بله</option>
						<option :value="false">خیر</option>
						<option :value="null">ندارد</option>
					</select>
					<select class="w-100" v-model="modalScore" v-if="model.name === 'Score'">
						<option :value="1">‍۱</option>
						<option :value="2">۲</option>
						<option :value="3">۳</option>
						<option :value="4">۴</option>
						<option :value="5">۵</option>
					</select>
					<textarea
						v-if="model.name === 'Description'"
						v-model="ModalDescription"
						rows="4"
						cols="50"
						class="mt-4 w-100"
						style="border-radius: 8px"
					>
					</textarea>
					<div class="w-100" v-if="model.name === 'DropDownList'">
						<Multiselect
							:options="modalDropdownChoice"
							v-model="modalDropdownAnswer"
							:custom-label="customLabel"
							placeholder="لطفا یک مورد را انتخاب نمایید"
							selectLabel=""
							class="mt-4"
							@select="modalDropdownAnswer"
						></Multiselect>
					</div>
					<div v-if="model.name === 'RadioChoice'">
						<b-form-group>
							<b-form-radio-group
								v-model="modalRadio"
								:options="modalRadioChoices"
								value-field="id"
								text-field="answer"
								class="d-flex flex-column"
							></b-form-radio-group>
						</b-form-group>
					</div>
					<input class="w-100" v-if="model.name === 'Input'" v-model="modalInput" />
					<input
						class="my-2 edit-input w-100"
						v-if="model.name === 'Number'"
						v-model="modalNumberValue"
					/>
					<div v-if="model.name === 'Multichoice'">
						<p class="font-weight-bold">{{ multiChooseQuestion }}</p>
						<div v-for="multi in multiAnswerChooses" :key="multi.id">
							<input v-model="multiChoose" :value="multi.id" class="ml-2" type="checkbox" />
							<label>{{ multi.answer }}</label>
						</div>
					</div>
				</div>
			</div>
			<div class="btns">
				<button class="accept" @click="submitEdit">ثبت</button>
				<button @click="editModal = !editModal" class="reject">بستن</button>
			</div>
		</b-modal>
		<div class="image-box">
			<div class="btns mt-4 justify-content-start">
				<button @click="importImg" class="accept">افزودن عکس</button>
			</div>
			<b-modal hide-footer hide-header centered v-model="modalAddImage">
				<h5 class="mb-4">افزودن عکس</h5>
				<div v-for="photos in storeDetailPhotos" :key="photos.id">
					<div class="add-img">
						<span>{{ photos.verbose_name }}</span>
						<button @click="uploadImage(photos.id)" class="select-img">افزودن عکس</button>
						<input
							type="file"
							hidden
							capture="user"
							accept="image/*"
							id="fileUpload"
							@change="func($event)"
						/>
					</div>
				</div>
			</b-modal>

			<Tableview
				:hover="true"
				:bordered="true"
				:showNoContent="showContnetFunc"
				:showNoData="showDataFunc"
				class="mt-4"
			>
				<template #TableTitle>
					<tr>
						<th>ردیف</th>
						<th>عنوان</th>
						<th>تصویر</th>
						<th>تایید تصویر</th>
						<th>نتیجه پردازش</th>
						<th>تاریخ</th>
						<th>لوکیشن</th>
						<th>تایید سرپرست</th>
						<th>تایید لوکیشن</th>
						<th>فاصله</th>
						<th>عملیات</th>
					</tr>
				</template>

				<template #TableBody>
					<tr v-for="(item, index) in images" :key="item.id">
						<td class="persian-number">
							{{ 1 + index }}
						</td>
						<td>{{ item.type.verbose_name }}</td>
						<td>
							<img @click="callModalimage(index)" class="images" :src="item.link" />
						</td>
						<td>
							<img
								@click="verifyImage(item)"
								class="images"
								src="../../assets//images/iconPack/auth-img.svg"
							/>
						</td>
						<td>
							<span v-if="item.recognition_status == null">نامشخص</span>
							<span v-if="item.recognition_status == 1">نقص پروفایل</span>
							<span v-if="item.recognition_status == 2">عدم تشخیص چهره</span>
							<span v-if="item.recognition_status == 3">عدم تطابق</span>
							<span v-if="item.recognition_status == 4">تطابق</span>
						</td>
						<td>
							<date-picker
								v-model="item.datetime_created"
								type="datetime"
								format="YYYY-MM-DD HH:mm"
								display-format="jYYYY-jMM-jDD HH:mm"
								:timezone="true"
								:disabled="true"
							/>
						</td>
						<td>
							<span class="location" @click="showLocation(item)">مشاهده</span>
						</td>
						<td>
							<span v-if="item.supervision_confirm === 'NOT_CHECKED'">بررسی نشده</span>
							<span v-if="item.supervision_confirm === 'CONFIRMED'">تایید شده</span>
							<span v-if="item.supervision_confirm === 'REJECTED'">رد شده</span>
						</td>
						<td>
							<span v-if="item.supervision_location_confirm === 'NOT_CHECKED'">بررسی نشده</span>
							<span v-if="item.supervision_location_confirm === 'CONFIRMED'">تایید شده</span>
							<span v-if="item.supervision_location_confirm === 'REJECTED'">رد شده</span>
						</td>
						<td>
							<span v-if="item.distance == -1">مشتری لوکیشن ندارد</span>
							<span v-if="item.distance == -2">عدم ثبت لوکیشن</span>
							<span v-if="item.distance == -3">عدم ثبت لوکیشن</span>
							<span v-if="item.distance == -4">خطای محاسبه</span>
							<span style="color: green" v-if="item.distance <= 30 && item.distance >= 0"
								>{{ Math.floor(item.distance) }} متر</span
							>
							<span style="color: orange" v-if="item.distance > 30 && item.distance <= 100"
								>{{ Math.floor(item.distance) }} متر</span
							>
							<span style="color: red" v-if="item.distance > 100"
								>{{ Math.floor(item.distance) }} متر</span
							>
						</td>

						<td>
							<img
								class="delete-img"
								@click="modalDeleteImg(item)"
								src="@/assets/images/iconPack/red-trash.svg"
							/>
						</td>
					</tr>
				</template>
			</Tableview>
			<b-modal hide-footer hide-header size="lg" centered v-model="imageModal">
				<b-carousel
					id="carousel-fade"
					style="text-shadow: 1px 1px 2px #333"
					v-if="images.length"
					controls
					indicators
					background="#ababab"
					fade
					v-model="carouselIndex"
					interval="120000"
				>
					<b-carousel-slide
						v-for="(image, index) in images"
						:key="index"
						:img-src="image.link"
					></b-carousel-slide>
				</b-carousel>
				<!-- <img class="modal-img" :src="imageUrl" /> -->
			</b-modal>
			<b-modal hide-footer hide-header centered v-model="modalTrash">
				<h5 class="mb-4">حذف عکس</h5>
				<span>آیا از حذف این عکس اطمینان دارید؟</span>
				<div class="btns mt-4">
					<button @click="deleteImg" class="accept">تایید</button>
					<button @click="modalTrash = !modalTrash" class="reject">رد</button>
				</div>
			</b-modal>
			<div class="btns pb-4">
				<button @click="modalShow = !modalShow" class="accept">تایید</button>
				<button @click="rejectModal = !rejectModal" class="reject">رد</button>

				<b-modal v-model="modalShow" hide-footer hide-header centered>
					<p class="my-4">آیا از تایید خود اطمینان دارید؟</p>
					<div class="btns">
						<button @click="acceptVist" class="accept">تایید</button>
						<button @click="modalShow = !modalShow" class="reject">بستن</button>
					</div>
				</b-modal>
				<b-modal v-model="rejectModal" hide-footer hide-header centered>
					<p class="my-4">آیا از رد کردن اطمینان دارید؟ دلیل را توضیح دهید</p>
					<textarea
						style="border-radius: 8px"
						class="text-area"
						rows="4"
						cols="50"
						v-model="rejectReason"
					></textarea>
					<div class="btns">
						<button @click="rejectVisit" :disabled="reasonBtn" class="accept">تایید</button>
						<button @click="rejectModal = !rejectModal" class="reject">بستن</button>
					</div>
				</b-modal>
				<b-modal v-model="starModal" hide-footer hide-header centered>
					<p class="my-4">به اجرای این ویزیت چه امتیازی می دهید؟</p>
					<div class="star-rating">
						<span
							v-for="star in 5"
							:key="star"
							@click="rate(star)"
							:class="{ filled: star <= currentRating }"
						>
							<img
								v-if="star <= currentRating"
								class="star-icon"
								src="@/assets/images/iconPack/Star_solid.svg"
								alt="Solid Star"
							/>
							<img
								v-else
								class="star-icon"
								src="@/assets/images/iconPack/Star_line.svg"
								alt="Outline Star"
							/>
						</span>
					</div>
					<div class="btns">
						<button @click="submitStar" class="accept">تایید</button>
						<button @click="declineStar" class="reject">رد کردن</button>
					</div>
				</b-modal>
			</div>
			<b-modal scrollable v-model="nullAnswersQuest" hide-footer hide-header centered>
				<div class="d-flex justify-content-center">
					<b-spinner v-if="nullAnswerLoading" label="Spinning"></b-spinner>
				</div>
				<div v-if="nullAnswersLists.length === 0 && nullAnswerLoading === false">
					هیچ سوال پاسخ داده نشده ای وجود ندارد!
				</div>
				<div v-for="(nullAnswers, index) in nullAnswersLists" :key="'null' + index">
					<div class="modal-question-container" v-if="nullAnswers.submitted_answer.id === null">
						{{ nullAnswers.question.text }}
						<button @click="createFeild(nullAnswers)" class="select-questions">افزودن پاسخ</button>
					</div>
				</div>
				<!-- <div class="d-flex w-100 justify-content-center">
					<button class="select-questions" v-if="nullAnswersLists.length > 0 && nullAnswerLoading === false" @click="loadMore">مشاهده بیشتر</button>
				</div> -->
			</b-modal>
		</div>
		<Loading v-if="loading" />
	</div>
</template>
<script>
import Tableview from '../../components/Tableview/index.vue';
import Multiselect from 'vue-multiselect';
import axios from 'axios';
import Loading from '../../components/Loading/index.vue';
export default {
	components: {
		Tableview,
		Multiselect,
		Loading,
	},
	data() {
		return {
			catList: [],
			answerList: [],
			visits: {},
			images: 0,
			storeDetailPhotos: [],
			imageModal: false,
			modalShow: false,
			rejectModal: false,
			rejectReason: null,
			imageUrl: null,
			editModal: false,
			modaltext: '',
			modalAnswerType: [],
			modalNumberValue: null,
			modalAnswerId: '',
			modalShortText: '',
			modalBool: null,
			modalScore: null,
			ModalDescription: null,
			modalAddImage: false,
			photoId: null,
			modalTrash: false,
			imgId: null,
			multiChoose: [],
			multiAnswerChooses: [],
			multiChooseQuestion: '',
			commentData: {},
			modalName: '',
			modalLastName: '',
			modalInput: null,
			modalRadio: null,
			modalDropdownAnswer: {},
			modalDropdownChoice: [],
			modalRadioChoices: [],
			loading: false,
			nullAnswersQuest: false,
			nullAnswersLists: [],
			modalQuestionId: null,
			nullAnswerLoading: false,
			itemsPerPage: 5,
			currentPage: 1,
			allItems: [],
			currentRating: 0,
			starModal: false,
			carouselIndex: 0,
		};
	},
	mounted() {
		// Attach the scroll event listener
		// window.addEventListener('scroll', this.checkScroll);

		// Fetch more items when the component is initially loaded if needed
		// this.checkScroll();
		this.getCategoryList();
		this.getAnswerList();
		this.getImageList();
		this.getVisitSetting();
		this.comment();
		this.getVisitDetails();
	},
	computed: {
		reasonBtn() {
			if (this.rejectReason === null || this.rejectReason.length === 0) {
				return true;
			} else {
				return false;
			}
		},
		hasMore() {
			return this.nullAnswerLoading.length < this.allItems.length;
		},
		showContnetFunc() {
			return this.images === 0;
		},
		showDataFunc() {
			if (this.images.length !== undefined) {
				return this.images.length === 0;
			}
			return false;
		},
	},
	// beforeDestroy() {
	// 	// Remove the scroll event listener to prevent memory leaks
	// 	window.removeEventListener('scroll', this.checkScroll);
	// },
	methods: {
		// loadMore() {
		// 	const startIndex = (this.currentPage - 1) * this.itemsPerPage;
		// 	const endIndex = startIndex + this.itemsPerPage;

		// 	this.nullAnswersLists = [...this.nullAnswersLists, ...this.allItems.slice(startIndex, endIndex)];

		// 	// Increment the current page
		// 	this.currentPage++;
		// },
		customLabel({ answer }) {
			return `${answer}`;
		},
		async getCategoryList() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.REPORT_CAT_LIST +
					'?visit_id=' +
					lastParam +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&is_for_supervision=' +
					false,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.catList = res.data;
			}
		},

		async getVisitDetails() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.VISIT_DETAIL_EDIT +
					lastParam +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.visits = res.data;
			}
		},
		async getVisitSetting() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.VISIT_PAGE_SETTING +
					lastParam +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.storeDetailPhotos = res.data.photos;
			}
		},

		uploadImage(id) {
			this.photoId = id;
			document.getElementById('fileUpload').click();
		},
		async verifyImage(item) {
			this.loading = true;
			const apiUrl = 'https://face.koosha.ir/recognize/check_face/';
			axios
				.post(apiUrl, {
					matching_id: item.visit.promoter.id,
					image: item.link,
					is_for: 'V',
					for_id: item.id,
				})
				.then((response) => {
					if (response.data.result.is_matched === true) {
						this.loading = false;
						this.$notify({
							group: 'tc',
							type: 'success',
							text: 'تصویر مطابقت دارد.',
						});
					} else {
						this.loading = false;
						this.$notify({
							group: 'tc',
							type: 'danger',
							text: 'تصویر مطابقت ندارد.',
						});
					}
					response;
				})
				.catch((error) => {
					this.loading = false;
					this.$notify({
						group: 'tc',
						type: 'danger',
						text: ' کاربر مورد نظر بخش احراز هویت را تکمیل نکرده است!',
					});
					console.error('Error fetching data:', error);
				});
		},
		modalDeleteImg(item) {
			this.modalTrash = true;
			this.imgId = item.id;
		},
		async nullAnswers(catId) {
			this.nullAnswerLoading = true;
			this.nullAnswersLists = [];
			this.nullAnswersQuest = true;
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_VISIT_QUESTIONS +
					lastParam +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&report_category=' +
					catId +
					'&question_type__is_for_supervision=' +
					false,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.nullAnswerLoading = false;
				// const newData = res.data;
				// this.allItems = this.allItems.concat(newData);
				// this.loadMore();
				this.nullAnswersLists = res.data;
			}
		},
		// checkScroll() {
		// 	const scrollY = window.scrollY;
		// 	const windowHeight = window.innerHeight;
		// 	const bodyHeight = document.body.clientHeight;

		// 	if (scrollY + windowHeight >= bodyHeight - 200 && this.hasMore) {
		// 		// Load more items when the user is near the end of the page
		// 		this.loadMore();
		// 	}
		// },
		async submitEdit() {
			console.log(this.multiChoose);
			let res = null;
			this.loading = true;
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const data = {
				score: this.modalScore,
				bool: this.modalBool,
				description: this.ModalDescription,
				number: this.modalNumberValue,
				multichoice: this.multiChoose,
				text: this.modalInput,
				radio: this.modalRadio,
				dropdown: this.modalDropdownAnswer !== null ? this.modalDropdownAnswer.id : null,
				visit: lastParam,
			};
			if (this.modalAnswerId === null) {
				(data['question'] = this.modalQuestionId),
					(res = await this.$ApiServiceLayer.post(
						this.$PATH.RELATIVE_PATH.POST.VISIT_ANSWER_EDIT +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
						this.$PATH.SERVICE_NAME.AUTH,
						data,
						{},
						true,
					));
			} else {
				res = await this.$ApiServiceLayer.patch(
					this.$PATH.RELATIVE_PATH.MULTI.ANSWER_EDIT + this.modalAnswerId + '/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
					this.$PATH.SERVICE_NAME.AUTH,
					data,
					{},
					true,
				);
			}
			if (res.status === 200 || res.status === 201) {
				this.loading = false;
				this.$notify({
					group: 'tc',
					type: 'success',
					text: ' بروزرسانی با موفقیت انجام شد.',
				});
				this.multiChoose = [];
				this.getAnswerList();
				// this.nullAnswers();
				this.editModal = false;
				this.nullAnswersQuest = false;
			}
			// const res = await this.$ApiServiceLayer.patch(
			// 	this.$PATH.RELATIVE_PATH.MULTI.ANSWER_EDIT + this.modalAnswerId + '/',
			// 	this.$PATH.SERVICE_NAME.AUTH,
			// 	data,
			// 	{},
			// 	true,
			// );
			// (res);
			// if (res.status === 200) {
			// 	this.$notify({
			// 		group: 'tc',
			// 		type: 'success',
			// 		text: ' بروزرسانی با موفقیت انجام شد.',
			// 	});
			// 	this.editModal = false;
			// 	this.getAnswerList();
			// }
		},
		async func(event) {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			'thisis:', event.target.files[0];
			let formData = new FormData();
			formData.append('link', event.target.files[0]);
			formData.append('latitude', null);
			// formData.append("latitude", "10");
			formData.append('longitude', null);
			// formData.append("longitude", "10");
			formData.append('visit', lastParam);
			formData.append('type', this.photoId);
			const res = await this.$ApiServiceLayer.post(
				this.$PATH.RELATIVE_PATH.POST.UPLOAD_IMAGE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				formData,
				{
					'Content-Type': 'multipart/form-data',
				},
			);
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: ' بارگزاری با موفقیت انجام شد.',
				});
				this.modalAddImage = false;
				this.getImageList();
			}
		},
		callModalimage(index) {
			this.imageModal = true;
			this.carouselIndex = index;
			// this.imageUrl = item.link;
		},
		editFeild(answers) {
			this.editModal = true;
			this.modalQuestionId = answers.question.id;
			this.modalInput = answers.text;
			this.modaltext = answers.question.text;
			this.modalNumberValue = answers.number;
			this.modalShortText = answers.question.short_text;
			this.modalBool = answers.bool;
			this.modalScore = answers.score;
			this.ModalDescription = answers.description;
			this.modalAnswerId = answers.id;
			this.modalAnswerType = answers.question.answer_type;
			this.modalRadio = answers.radio !== null ? answers.radio.id : null;
			this.modalRadioChoices = answers.question.radio_choices;
			this.modalDropdownAnswer = answers.dropdown;
			this.modalDropdownChoice = answers.question.dropdown_choices;
		},
		createFeild(answers) {
			this.modalQuestionId = answers.question.id;
			this.surveyFillOutId = window.location.href.split('/').slice(-1)[0];
			this.modaltext = answers.question.text;
			this.modalNumberValue = answers.submitted_answer.number;
			this.modalShortText = answers.question.short_text;
			this.modalBool = answers.submitted_answer.bool;
			this.modalScore = answers.submitted_answer.score;
			this.ModalDescription = answers.submitted_answer.description;
			this.modalAnswerId = answers.submitted_answer.id;
			this.modalAnswerType = answers.question.answer_type;
			this.modalInput = answers.submitted_answer.text;
			this.modalRadio =
				answers.submitted_answer.radio !== null ? answers.submitted_answer.radio.id : null;
			this.modalRadioChoices = answers.question.radio_choices;
			this.modalDropdownAnswer = answers.submitted_answer.dropdown;
			this.modalDropdownChoice = answers.question.dropdown_choices;
			this.editModal = true;
		},
		editMultiFeild(answers) {
			// ('assd',answers)
			this.modalAnswerType = answers.question.answer_type;
			this.modalAnswerId = answers.id;
			// this.multiChoose = answers.multichoice;
			this.getMultiChoose(answers.id);
			this.multiChooseQuestion = answers.question.text;
		},
		async getMultiChoose(id) {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.ANSWER_EDIT +
					id +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.editModal = true;
				this.multiAnswerChooses = res.data.question.answer_choices;
				'sadafsdf:', this.multiAnswerChooses;
			}
		},
		async comment() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.ADD_COMMENT +
					lastParam +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				{},
			);
			if (res.status === 200) {
				'co', res.data;
				this.commentData = res.data;
				this.modalName = res.data.comment_publisher.first_name;
				this.modalLastName = res.data.comment_publisher.last_name;
			}
		},
		async acceptComment() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.put(
				this.$PATH.RELATIVE_PATH.MULTI.ADD_COMMENT + lastParam + '/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				{
					visit_comment: this.commentData.visit_comment,
				},
			);
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'بازخورد با موفقیت تغییر کرد!',
				});
			}
		},
		async getAnswerList() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_VISIT_ANSWER_LIST +
					'?visit=' +
					lastParam +
					'&ordering=question__priority' +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&question__question_type__is_active=' +
					true +
					'&question__question_type__is_for_supervision=' +
					false,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.answerList = res.data;
				this.questions = res.data.question;
				// ('AAAN!', this.answerList);
			}
		},
		rate(rating) {
			this.currentRating = rating;
			this.sendRatingToServer(rating);
		},
		async sendRatingToServer(rating) {
			const data = {
				rate: rating,
				visit: window.location.href.split('/').slice(-1)[0],
			};
			const res = await this.$ApiServiceLayer.post(
				this.$PATH.RELATIVE_PATH.MULTI.VISIT_RATE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				data,
			);
			if (res.status === 201) {
				console.log(res.data);
			}
		},
		submitStar() {
			window.close();
		},
		declineStar() {
			window.close();
		},

		async getImageList() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_PHOTO_LIST +
					'?visit=' +
					lastParam +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&type__is_for_supervision=' +
					false +
					'&type__report_category__is_for_supervision=' +
					false,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.images = res.data;
				console.log('asd', this.images);
			}
		},
		importImg() {
			this.modalAddImage = true;
			this.getImageList();
		},
		deleteImg() {
			this.$ApiServiceLayer
				.delete(
					this.$PATH.RELATIVE_PATH.MULTI.DELETE_IMAGE + this.imgId + '/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
					this.$PATH.SERVICE_NAME.AUTH,
				)
				.then((response) => {
					if (response.status === 204) {
						this.$notify({
							group: 'tc',
							type: 'success',
							text: ' حذف عکس با موفقیت انجام شد.',
						});
						this.modalTrash = false;
						this.getImageList();
					}
				});
		},
		showLocation(item) {
			window.open(`https://maps.google.com/?q=${item.latitude},${item.longitude}`, '_blank');
		},
		async acceptVist() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.put(
				this.$PATH.RELATIVE_PATH.MULTI.VISITS_STATUS + lastParam + '/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				{ status: '3' },
			);
			if (res.status === 200) {
				this.starModal = true;
				this.modalShow = false;
			}
		},
		async rejectVisit() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.put(
				this.$PATH.RELATIVE_PATH.MULTI.VISITS_STATUS + lastParam + '/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				{ status: '4', rejection_reason: this.rejectReason },
			);
			if (res.status === 200) {
				window.close();
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.answer-list {
	padding: 24px;
	.detail-box {
		padding: 14px 24px;
		.titles {
			font-size: 18px;
		}
	}
	.dash-card {
		border: 1px dashed #c4c4c4;
		border-radius: 8px;
		padding: 16px;
		margin-bottom: 50px;
		background: #fff;
		border-radius: 8px;
	}
	.details {
		display: flex;
		align-items: center;
		font-size: 14px;
		margin-top: 8px;
		font-family: 'IRANYekanfa' !important;
		&:last-child {
			flex-direction: row;
			align-items: center;
			margin-top: 0;
		}
	}
	.box {
		background: #d9d9d9;
		border-radius: 8px;
		padding: 10px;
		min-width: 72px;
		display: flex;
		justify-content: center;
		margin-left: 10px;
		border-radius: 8px;

		.answers-box {
			font-size: 14px;
			color: #616162;
		}
		.persian-number {
			font-family: 'IRANYekanfa' !important;
			font-size: 14px;
			color: #616162;
		}
	}
	.images {
		max-width: 60px;
		border-radius: 8px;
	}
	.location {
		color: #007bff !important;
		cursor: pointer;
	}
}
.question-txt {
	font-size: 14px;
	margin-top: 8px;
}
.btns {
	display: flex;
	justify-content: flex-end;
	margin-bottom: 15px;
	.accept {
		background: #2d8b8b;
		border-radius: 8px;
		color: #fff;
		padding: 8px 40px;
		border: none !important;
		margin-left: 10px;
		border-radius: 8px;
	}
	.accept:disabled {
		background: #c4c4c4;
	}
	.reject {
		border: 1px solid #2d8b8b !important;
		border-radius: 8px;
		padding: 8px 40px;
		background: #fff;
		border-radius: 8px;
	}
}
.edit-input {
	// border: 1px solid #c4c4c4;
	text-indent: 10px;
	border-radius: 8px;
	font-family: 'IRANYekanfa' !important;
}
.modal-img {
	width: 100%;
}
.edit-icon {
	width: 25px;
	height: 25px;
}
.text-area {
	width: 100%;
	border: 1px solid #c4c4c4;
	border-radius: 8px;
	margin-bottom: 16px;
	padding: 4px;
	border-radius: 8px;
}
.short-text {
	font-weight: bold;
	margin-left: 10px;
}
.persian-number {
	font-family: 'IRANYekanfa' !important;
}
.add-img {
	display: flex;
	justify-content: space-between;
	border: 1px dotted #c4c4c4;
	margin-bottom: 10px;
	padding: 8px;
	align-items: center;
}
.select-img {
	background: #2d8b8b;
	border-radius: 8px;
	color: #fff;
	padding: 8px 10px;
	border: none;
}

.delete-img {
	max-width: 32px;
	cursor: pointer;
}
.answers-title {
	font-size: 18px;
	font-weight: 700;
}
.answers-images {
	max-width: 120px;
	border-radius: 8px;
}
.accept-modal {
	height: 38px;
	background: #2d8b8b;
	color: #fff;
	border: none !important;
	margin-left: 10px;
	min-width: 100px;
	border-radius: 8px;
}
.card {
	border: none !important;
	border-radius: 8px !important;
}
.image-box {
	background: #fff;
	padding: 24px;
	margin-top: 1.5rem;
}
.modal-question-container {
	display: flex;
	justify-content: space-between;
	border: 1px dotted #c4c4c4;
	margin-bottom: 10px;
	padding: 8px;
	align-items: center;
}
.select-questions {
	background: #2d8b8b;
	border-radius: 8px;
	color: #fff;
	padding: 8px 10px;
	border: none;
}
.desc {
	color: #c4c4c4;
	font-size: 14px;
}
.short_text {
	color: #c4c4c4;
	font-size: 16px;
}
.star-rating {
	font-size: 24px;
	cursor: pointer;
	display: flex;
	justify-content: center;
	margin-bottom: 24px;
	span {
		padding: 0 8px;
	}
}

.star-icon {
	width: 24px; /* Set width of the star icon */
	height: 24px; /* Set height of the star icon */
}
</style>

<style>
.vpd-icon-btn {
	display: none !important;
}
.vpd-input-group input {
	border: none !important;
	border-radius: 0;
	font-family: 'IRANYekanfa';
}
.vpd-input-group input:disabled {
	background: #fff;
	min-width: 130px;
	text-align: center;
}
.multiselect {
	text-align: right !important;
}
.multiselect__select {
	display: none !important;
}
.multiselect__tags {
	padding: 8px 20px 0 8px !important;
}
.custom-control-label::before {
	left: unset !important;
	margin-left: 20px;
	position: unset !important;
}

.custom-control-label {
	display: flex !important;
	align-items: center;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
